import * as React from 'react';
import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
// import { mapDispatchToProps } from 'utils/reduxUtils';
// import PText from 'components/Primatives/PText';
import H1 from 'components/Primatives/H1';
import { FluidSection } from 'components/FluidSection';

import { DataTable } from 'grommet';

interface ReduxStateProps {
    kpiData: KpiData;
    userId: string;
}

interface KpiData {
    completedSessions: number;
    providersWithBookingsList?: ProviderWithBookings[];
    numberOfActiveProviders: number;
    numberOfProviders: number;
    revenuePerProviderPerMonth: number;
}

interface ProviderWithBookings {
    numberOfBookings: number;
    providerCompany: ProviderCompany;
    providerData: ProviderData;
    providerCompanyName: string;
}

interface ProviderCompany {
    name: string;
    email: string;
    address: ProviderCompanyAddress;
}

interface ProviderCompanyAddress {
    city: string;
    country: string;
    postalCode: string;
    province: string;
    street: string;
}

interface ProviderData {
    email: string;
    name: string;
}

interface ComponentState {
    kpiFetchInterval: any;
    data?: any;
}

// interface ComponentProps {
//     man?: string;
// }

interface ReduxDispatchProps {
    getKPIInfo: (userId: string) => any;
}

type CombinedProps = ReduxDispatchProps /*& ComponentProps*/ & ReduxStateProps;

const minutes = (num: number): number => {
    return num * 60000;
};

const hours = (num: number): number => {
    return num * 3600000;
};
hours;

class KPITrackerPage extends Component<CombinedProps, ComponentState> {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            kpiFetchInterval: 0,
        };
    }

    componentDidMount() {
        this.props.getKPIInfo(this.props.userId);
        // console.log(this.props.userId);
        const kpiFetchInterval = setInterval(() => {
            // FETCH DATA EVERY TEN MINUTES
            this.props.getKPIInfo(this.props.userId);
        }, minutes(10));

        this.setState({
            kpiFetchInterval,
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.kpiData !== this.props.kpiData) {
            this.setState({
                data: this.props.kpiData.providersWithBookingsList,
            });
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.kpiFetchInterval);
    }

    render() {
        if (!this.props.kpiData) {
            return (
                <FluidSection>
                    <H1>Loading...</H1>
                </FluidSection>
            );
        }

        // console.log(this.props.kpiData.providersWithBookingsList);

        const text_truncate = function(str, length, ending) {
            if (length == null) {
                length = 100;
            }
            if (ending == null) {
                ending = '...';
            }
            if (str.length > length) {
                return str.substring(0, length - ending.length) + ending;
            } else {
                return str;
            }
        };

        const { providersWithBookingsList } = this.props.kpiData;

        const onSearch = search => {
            let newProvidersWithBookingsList;
            if (search) {
                const expressions = Object.keys(search).map(property => ({
                    property,
                    exp: new RegExp(search[property], 'i'),
                }));
                newProvidersWithBookingsList = providersWithBookingsList.filter(
                    data => {
                        return !expressions.some(
                            expressionObject =>
                                !expressionObject.exp.test(
                                    data.providerData.name,
                                ),
                        );
                    },
                );
                return this.setState({ data: newProvidersWithBookingsList });
            } else {
                return (newProvidersWithBookingsList = providersWithBookingsList);
            }
        };

        return (
            <Fragment>
                <FluidSection>
                    <H1>Key Performance Indicators:</H1>
                </FluidSection>
                <FluidSection>
                    <DataTable
                        // groupBy="providerCompanyName"
                        sortable={true}
                        style={{ width: '100%' }}
                        // resizeable={true}
                        data={this.state.data}
                        onSearch={onSearch}
                        columns={[
                            {
                                property: 'providerData.name',
                                header: 'Provider',
                                // primary: true,
                                // sortable: true,
                                search: true,
                                render: datum => {
                                    // console.log('DATUM', datum);
                                    return (
                                        <React.Fragment>
                                            {datum.providerData &&
                                                text_truncate(
                                                    datum.providerData.name,
                                                    20,
                                                    '...',
                                                )}
                                        </React.Fragment>
                                    );
                                },
                            },
                            {
                                property: 'providerCompanyName',
                                header: 'Company',
                                sortable: true,
                                // primary: true,
                                render: datum => (
                                    <React.Fragment>
                                        {datum.providerCompanyName}
                                    </React.Fragment>
                                ),
                            },
                            {
                                property: 'numberOfBookings',
                                header: 'Bookings',
                                sortable: true,
                            },
                        ]}
                    />
                </FluidSection>

                {/* <ul>
                        {this.props.kpiData &&
                            Object.keys(this.props.kpiData).map((kpiKey, i) => {
                                return (
                                    <li key={i} style={{ fontSize: 36 }}>
                                        {kpiKey} {this.props.kpiData[kpiKey]}
                                    </li>
                                );
                            })}
                    </ul> */}
            </Fragment>
        );
    }
}

import { getKPIInfo } from '../../actions';

const actionCreators: any[] = [getKPIInfo];
actionCreators;

const mapStateToProps = ({ auth, kpi }): ReduxStateProps => ({
    userId: auth.authData.uid,
    kpiData: kpi.data,
});

const mapDispatchToProps = (dispatch): ReduxDispatchProps => {
    // console.log('Running MDTP for KPI Data...');
    return {
        getKPIInfo: uid => dispatch(getKPIInfo(uid)),
    };
};

// export default connect(mapStateToProps, (dispatch) => mapDispatchToProps({ dispatch, actionCreators }))(KPITrackerPage);
export default connect<ReduxStateProps, ReduxDispatchProps>(
    mapStateToProps,
    mapDispatchToProps,
)(KPITrackerPage);



// WEBPACK FOOTER //
// ./src/js/containers/KPITrackerPage/KPITrackerPage.tsx